import styled from 'styled-components';

const StyledSeparator = styled.div`
  width: 100%;
  border-top: 1px solid ${({ theme }: any) => theme.colors.primary[10]};
`;

const Separator = () => <StyledSeparator className="separator" />;

export default Separator;
